import axios from 'axios';
import React, { useContext, useEffect, useReducer, useRef, useState } from 'react';
import { systemCode, xs_languageCode } from '../..';
import Betslip from '../../common/Betslip';
import GoUpBtn from '../../common/GoUpBtn';
import IconsScroller from '../../common/IconsScroller';
import Loader from '../../common/Loader';
import MessageInfo from '../../common/MessageInfo';
import SportSelection from '../../common/SportSelection';
import LiveContext from '../../contexts/LiveContext';
import { dataFetchReducer } from '../../data/data';
import { useFetchSeoSettings } from '../../data/fetchSeoSettings';
import { parseLiveData } from '../../data/parseLiveData';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import SeoMainContainer from '../../data/seo/SeoMainContainer';
import SeoMetaTags from '../../data/seo/SeoMetaTags';
import { useHandleSeoSettings } from '../../data/seo/seoUtils';
import { getConfiguration, iconSportCssClass } from '../../data/utils';
import { getLabel } from '../../data/labels';
import { initMultiLiveEffects } from '../../sport-effects';
import { setAvailableSpaceForTables } from '../../tables-utils';
import MultiLiveMatch from './MultiLiveMatch';
import MultiLiveMatchBox from './MultiLiveMatchBox';
import { BetslipContext } from '../../data/betslip/BetslipConf';

function MultiLive(props) {
    const cfgSeo = getConfiguration().seo;
    const liveContext = useContext(LiveContext);
    const seoContext = React.useContext(SeoContext);
    const ctxs = useRef({}).current;
    ctxs.betslipContext =  useContext(BetslipContext);
    const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname,false,cfgSeo);

    useHandleSeoSettings(seoSettingsState);

    // Abilita scrolling
    useEffect(function() {
        window.setHeight();
        setAvailableSpaceForTables();
    });
    
    //NEW
    const [data, setData] = useState(null);
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    //OLD
    const [currentSport, setSport] = useState(0);
    const [matches, setMatches] = useState([]);
    const [showLoader,setShowLoader] = useState(true);

    //NEW
    useEffect(() => {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('ERRORE FETCH: '  + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };
        
        const url = getConfiguration().api.getMenuLiveSingleMatchPage;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: ''
        };
        fetchData(url, params, function(response) {
            const parsedData = response ? parseLiveData(response, false) : null;
            setData(parsedData);
            liveContext.setData(parsedData);
            dispatch({ type: 'FETCH_SUCCESS' }); // reload 2   
        });

        const intervalMillis = getConfiguration()?.lpo ?? 10000;
        const interval =   setInterval(() => {
            if(!ctxs?.betslipContext?.betInProgress) {
                setShowLoader(false);
                fetchData(url, params, function(response) {
                    const parsedData = response ? parseLiveData(response, false) : null;
                    setData(parsedData);
                    liveContext.setData(parsedData);
                    dispatch({ type: 'FETCH_SUCCESS' });           
                });
            }
        }, intervalMillis);
        
        return () => {
            didCancel = true;
            clearInterval(interval);
            setShowLoader(true);
        };
    }, []);

    useEffect(() => {
       if (data && data.sportById && (data.sportById[currentSport] || null) == null) {
            removeCurrentSportMatches();
       }
    }, [data]);
    
    const matchesById = {};
    const matchesBySport = {};
    if(data != null){
    	data.sport.forEach(function(sport) {
    		const currentSportEvents = [];
    		sport.categories.forEach(function(country) {
    			country.tournaments.forEach(function(tournament) {
    				tournament.events.forEach(function(match) {
    					match.sportId = sport.id;
    					match.tournamentDesc = tournament.descrizione;
                        match.iconClass = tournament.iconClass;
    					matchesById[match.uniqueId] = match;
    					currentSportEvents.push(match);
    				});
    			})
    		});
    		matchesBySport[sport.id] = currentSportEvents;
    	});
    }

    useEffect(() => {
        initMultiLiveEffects();
    }, [state.isLoading]);

    function addMatch(match) {
        if (matches.indexOf(match) === -1) {
            setMatches(matches.concat(match));
        }
    }

    function removeMatch(matchId) {
        const updatedMatches = Array.from(matches).filter(function(match){
        	return match != matchId;
        });
        setMatches(updatedMatches);
    }

    function removeCurrentSportMatches() {
    	setSport(0);
    }

    function changeSport(sport) {
        setSport(sport);
    }

    const sportSelectionsList = data?.sport?.map(function(sport) {
        return (
            <SportSelection key={sport.id} {...sport} selected={sport.id === currentSport} counter={matchesBySport[sport.id].length} changeSport={changeSport} />
        );
    });

    const matchBoxesList = currentSport == 0 ?
    		(Array.from(Object.keys(matchesById)).filter(function(matchId) {
		        return matches.indexOf(matchId) === -1;
		    }).map(function(matchId){
    			return (
		            <MultiLiveMatchBox key={matchId} {...matchesById[matchId]} addMatch={addMatch} />
		        );
    		}))
    		:
    		(matchesBySport?.[currentSport]?.filter(function(match) {
		        return matches.indexOf(match.uniqueId) === -1;
		    }).map(function(match) {
		        return (
		            <MultiLiveMatchBox key={match.uniqueId} {...match} addMatch={addMatch} />
		        );
		    }));

    const matchesList = matches.map(function(matchId) {
        return (
            matchesById[matchId] && <MultiLiveMatch key={matchId} match={matchesById[matchId]} removeMatch={removeMatch} openMatch={liveContext.openMatch} />
        );
    });

    const iconsContainer = useRef(null);

    if ((state.isLoading && showLoader) || state.isError) {
        return <Loader error={state.isError} />;
    }

    if (data == null) {
        return (
            <MessageInfo message={getLabel('general.eventi_live') + ' ' + getLabel('general.chiuso')} />
        )
    }

    const icoSport = iconSportCssClass(currentSport, props.iconClass);

    return (
        <>
        <SeoMetaTags />
        <div className="container-fluid pagina-sport bg-grigio-chiaro padding-su-1x">
            <div className="row no-gutters sport-griglia">
                <div className="griglia-centrale-sport col stringimento-sidebar" id="div-centrale">
                    <div className="contenitore-schedine-sport">
                        <div className="competizione-interna multibet-gruppo">
                            <div id="primo-blocco-sport" className="sport-blocco primo-blocco-sport go-up-arrow-on-overflow">
                                <GoUpBtn />
                                <div className="sport-live-suite" id="calcio">
                                    <div className="container-slider-icone mb-2 overflow-unset has-icons-container-no-wrap">
                                        <div className="slider-icone-sport horiz-sc icons-container icons-container-no-wrap" ref={iconsContainer}>
                                            {sportSelectionsList}
                                        </div>
                                        <IconsScroller buttons={sportSelectionsList} iconsContainer={iconsContainer.current} />
                                    </div>
                                    <div className="bg-nero bianco titolo-blocco-sport pointer">
                                        <span className="d-centro-v maiuscolo">
                                            <div className={`img-fluid icona-sport margine-dx-mezzo ico-sport ${icoSport}`}></div>
                                            { currentSport == 0 ? getLabel('general.tutti') : data?.sportById?.[currentSport]?.descrizione}
                                        </span>
                                        <div className="tool-multilive">
                                            <i className="fas fa-times pointer" onClick={removeCurrentSportMatches}></i>
                                        </div>
                                    </div>
                                    <div className="bg-bianco margine-giu-mezzo show bordo-tondo">
                                        {matchBoxesList?.length > 0 &&
                                            <div className="container-slider-box-partite">
                                                <div className="slider-box-partite horiz-sc">
                                                    {matchBoxesList}
                                                </div>
                                                <div className="paddles-box-partite">
                                                    <div className="left-paddle-box-partite paddle-box-partite d-none"><i className="fas fa-chevron-left"></i></div>
                                                    <div className="right-paddle-box-partite paddle-box-partite"><i className="fas fa-chevron-right"></i></div>
                                                </div>
                                            </div>
                                        }
                                        {matchesList?.length > 0 &&
                                            <div className="contenitore-multilive d-grid colonne-3">
                                                {matchesList}
                                            </div>
                                        }
                                    </div>
                                    <SeoMainContainer />
                                </div>
                               {/*  <Legend /> */}
                            </div>
                        </div>
                    </div>
                </div>
                <Betslip />
            </div>
        </div>
        </>
    );
}

export default MultiLive;